export class UrlUtility {

    static getUrlParam = (url, param) => {
        let pstr = url.split("?");
        if (pstr.length > 1) {
            let p = pstr[1].split('&').map((str) => str.split("=")).filter((arr) => arr.length && arr[0] == param);
            if (p.length && p[0].length > 1) {
                return p[0][1];
            }
        }
        return null;
    }

    static getUrlParams = (url) => {
         let pstr = url.split("?");
         if (pstr.length > 1) {
             return pstr[1];
         }
         return '';
    }
}